import { AlarmFilterEnum } from "@Safemate/DeviceList/AlarmFilterEnum";
import { StatusEnum } from "./StatusEnum";

type GetStatusLink = (status: StatusEnum) => AlarmFilterEnum;

export const getStatusLink: GetStatusLink = (status) => {
  switch(status){
    case StatusEnum.FIRE_WARNING:
      return AlarmFilterEnum.FIRE;
    case StatusEnum.ALARM_WARNING:
      return AlarmFilterEnum.ALARM
    case StatusEnum.GEOFENCE_WARNING:
      return AlarmFilterEnum.GEOFENCE;
    case StatusEnum.SELF_CHECK_WARNING:
      return AlarmFilterEnum.SELFCHECK;
    case StatusEnum.OUT_OF_BED_WARNING:
      return AlarmFilterEnum.OUT_OF_BED;
    case StatusEnum.FRIDGE_WARNING:
      return AlarmFilterEnum.FRIDGE;
    case StatusEnum.IN_BED_WARNING:
      return AlarmFilterEnum.IN_BED;
    case StatusEnum.OUT_OF_BATTERY_WARNING:
      return AlarmFilterEnum.OUT_OF_BATTERY;
    case StatusEnum.OFFLINE_WARNING:
      return  AlarmFilterEnum.OFFLINE;
    case StatusEnum.TCP_STATUS_DISABLED_WARNING:
      return AlarmFilterEnum.TCP_DISABLED;
    case StatusEnum.OUTDATED_POSITION_WARNING:
      return AlarmFilterEnum.OUTDATED_POSITION;
    case StatusEnum.BATTERY_WARNING:
      return AlarmFilterEnum.BATTERY;
    case StatusEnum.INACTIVE_WARNING:
      return AlarmFilterEnum.STATIC;
    case StatusEnum.NEVER_USED:
      return AlarmFilterEnum.NEVER_USED;
    case StatusEnum.GENERAL_WARNING:
      return AlarmFilterEnum.GENERAL;
    case StatusEnum.OK:
      return AlarmFilterEnum.OK;
    default:
      return AlarmFilterEnum.CLEAR;
  }
}